import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Button, Table, Card, Descriptions, Input } from 'antd';
import styles from './index.less'
import { print } from "@/utils/printUtils";
import moment from 'moment'
import 'braft-editor/dist/index.css'
import 'braft-extensions/dist/table.css'
import BraftEditor from 'braft-editor'
import Common from '../../components/commonTable/commonShowComponent';


const { TextArea } = Input;

const PrintModal = ({
  taskDetail = {},
  infos = {},
  visible,
  type,
  formType='default',
  ...other
}) => {
  const controls = []

  const [info, setInfo] = useState({})

  useEffect(() => {
     
    if (infos) {
      setInfo({ ...infos })
    }
  }, [infos])

  const handlePrint = () => {
    const printContent = document.getElementById("printDetails").parentNode;
    setTimeout(() => {
      print(printContent);
    }, 1500);
  }

  const modalProps = {
    visible: visible,
    // onCancel,
    width: 800,
    okText: '打印',
    ...other
  };

  if (type === 'view') {
    modalProps.footer = null
  }

  const handleChange = (key, value) => {
    let newInfo = { ...info }
    newInfo[key] = value
    setInfo({ ...newInfo })
  }

  return (
    // <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>

    // </Modal>
    <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>
      {formType === 'default'?
      <div id='printDetails'>
        <div className={styles.BSPPrint} id='printDetails'>
          <h2 className={'print-title'} style={{ textAlign: 'center' }}>艺术疗愈记录表</h2>
          {(info.evaluationAnalysisResult||info.documentDate||info.count)&&
          <div>
            <Descriptions bordered>
              <Descriptions.Item span={1} label="评估分析结果">{info.evaluationAnalysisResult}</Descriptions.Item>
              <Descriptions.Item span={1} label="日期时间">{info.documentDate && moment(info.documentDate).format('YYYY-MM-DD HH:mm:ss')}</Descriptions.Item>
              <Descriptions.Item span={1} label="次数">第{info.count}次</Descriptions.Item>
            </Descriptions>
          </div>
          }
          <div className={styles.bspCommontContain}>
            <Descriptions bordered column={1}>
              {info.stageGoal&&
              <Descriptions.Item label="阶段目标" span={1}><div style={{ padding: '8px 16px' }}>
                <TextArea value={info.stageGoal} autoSize={{ minRows: 1 }} onChange={e => handleChange('stageGoal', e.target.value)} />
              </div></Descriptions.Item>
              }
              {info.thisTimeGoal&&
              <Descriptions.Item label="本次目标" span={1}><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.thisTimeGoal} autoSize={{ minRows: 1 }} onChange={e => handleChange('thisTimeGoal', e.target.value)} />
              </div></Descriptions.Item>
              }
              {info.guideLanguage && <Descriptions.Item label="引导语" span={1}><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.guideLanguage} autoSize={{ minRows: 1 }} onChange={e => handleChange('guideLanguage', e.target.value)} />
              </div></Descriptions.Item>}
              {info.commonWords && <Descriptions.Item label="常用话术" span={1}><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.commonWords} autoSize={{ minRows: 1 }} onChange={e => handleChange('commonWords', e.target.value)} />
              </div></Descriptions.Item>}
              {info.paint && <Descriptions.Item label="绘画作品" span={1}>
                <div style={{ padding: '0' }}>
                  <BraftEditor
                    // readOnly={true}
                    controls={controls}
                    // style={{ height: 'auto' }}
                    contentStyle={{ height: 'auto', }}
                    id='editor-1'
                    value={BraftEditor.createEditorState(info.paint)}
                  // extendControls={extendControls}
                  />
                </div>
              </Descriptions.Item>}
              {info.visitDescription && <Descriptions.Item label="来访描述" span={1}><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.visitDescription} autoSize={{ minRows: 1 }} onChange={e => handleChange('visitDescription', e.target.value)} />
              </div></Descriptions.Item>}
              {info.visitingSubjectiveFeelings && <Descriptions.Item label="来访主观感受" span={1}><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.visitingSubjectiveFeelings} autoSize={{ minRows: 1 }} onChange={e => handleChange('visitingSubjectiveFeelings', e.target.value)} />
              </div></Descriptions.Item>}
              {info.consultantInterpretation && <Descriptions.Item label="咨询师解读" span={1}><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.consultantInterpretation} autoSize={{ minRows: 1 }} onChange={e => handleChange('consultantInterpretation', e.target.value)} />
              </div></Descriptions.Item>}
              {info.coreConversationRecord && <Descriptions.Item label="预留作业" span={1}><div style={{ padding: '8px 16px' }}>
              <TextArea value={info.coreConversationRecord} autoSize={{ minRows: 1 }} onChange={e => handleChange('coreConversationRecord', e.target.value)} />
              </div></Descriptions.Item>}
              {info.otherSituationRecord && <Descriptions.Item label="其他情况补充记录" span={1}>
                <div style={{ padding: '0' }}>
                  <BraftEditor
                    // readOnly={true}
                    controls={controls}
                    // style={{ height: 'auto' }}
                    contentStyle={{ height: 'auto', }}
                    id='editor-1'
                    value={BraftEditor.createEditorState(info.otherSituationRecord)}
                  // extendControls={extendControls}
                  />
                </div>
              </Descriptions.Item>}
            </Descriptions>
          </div>
        </div>
      </div>
      :<Common result={info}/>}
    </Modal>

  );
};

export default Form.create()(PrintModal);
